import pdfApi from '~/clientApis/pdfApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { PosterGroup } from '~/definitions/poster';
import { getStore } from '~/mobx/AppStore';
import downloadFromBlob from '~/utils/downloadFromBlob';

async function createRegionPreviewPoster(candidates: PosterGroup['candidates'], size: string) {
    const { regionPreviewStore, regionStore } = getStore();
    try {
        regionPreviewStore.setIsDownloadingRegionPreview(true);
        const result = await pdfApi.downloadPDF({
            layout: candidates,
            size: size,
            regionId: regionStore.selectedRegionId,
        });

        if (!result) {
            return null;
        }

        let filename = result.headers.get('content-disposition')?.split('filename=')[1] || 'product.pdf';
        filename = filename.replace(/"/g, ''); // Remove double quotes

        const blob = await result.blob();
        downloadFromBlob(filename, blob);
    } catch (error) {
        const errorMessage = (await (error as Response).json()).error || 'Error downloading PDF';
        showMessageModal('error', errorMessage);
    } finally {
        regionPreviewStore.setIsDownloadingRegionPreview(false);
    }
}

export default createRegionPreviewPoster;
